import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { HorizontalCard } from '../../partials/cards/horizontalCard/HorizontalCard';
import { VerticalCard } from '../../partials/cards/verticalCard/VerticalCard';
import { useTheme } from '../../../theming/useTheme';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';
import { MEDIA_BREAKPOINTS } from '../../../mediaQueries.const';
import { BaseUnit } from '../../../theming/baseUnitDefinition';
import { CardComponentDataProps } from '../../partials/cards/cards.utils';
import { createImageWidths } from '../../partials/image/image.utils';
import { getLayoutComponentPadding, LayoutComponentBaseProps } from '../pageLayouts/layout.utils';

const createStyle = (baseUnit: BaseUnit) => StyleSheet.create({
  container: {
    display: 'grid',
    gridColumnGap: `${baseUnit / 2}px`,
    gridTemplateRows: '1fr',
    gridTemplateColumns: '1fr 1fr',
    [MEDIA_BREAKPOINTS.small]: {
      gridColumnGap: '0',
      gridRowGap: `${baseUnit / 2}px`,
      gridTemplateRows: 'auto',
      gridTemplateColumns: '1fr',
    },
  },
  horizontalCardsWrapper: {
    position: 'relative',
  },
  horizontalCardsContainer: {
    maxHeight: '100%',
    height: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridTemplateRows: '1fr 1fr 1fr',
    gridRowGap: `${baseUnit / 2}px`,
  },
  horizontalCardWrapper: {
    minWidth: '0',
    minHeight: '0',
    boxSizing: 'border-box',
    padding: '0.1px',
    position: 'relative',
    ':last-child': {
      marginBottom: '0',
    },
  },
});

interface OneThreeArticleListComponentDataProps extends LayoutComponentBaseProps {
  cardsProps: CardComponentDataProps[];
}

interface OneThreeArticleListComponentThemeProps {
  baseUnit: BaseUnit;
}

const imageWidthsHorizontalCard = createImageWidths(180, 180, 180);
const imageWidthsVerticalCard = createImageWidths(360, 720, 540);

export const OneThreeArticleList: React.FunctionComponent<OneThreeArticleListComponentDataProps> = ({ cardsProps = [], paddingFactors }) => {
  const [highlight, ...moreCards] = cardsProps;
  const { baseUnit } = useTheme<OneThreeArticleListComponentThemeProps>();
  const style = createStyle(baseUnit);
  const paddingStyle = getLayoutComponentPadding(paddingFactors);

  const createCard = (cardProps: CardComponentDataProps, i: number) => (
    <div className={css(style.horizontalCardWrapper)} key={i}>
      <HorizontalCard {...cardProps} imageWidths={imageWidthsHorizontalCard} />
    </div>
  );

  return (
    <ErrorBoundary>
      {cardsProps.length > 0
      && (
      <div className={css(paddingStyle, style.container)}>
        <VerticalCard {...highlight} imageWidths={imageWidthsVerticalCard} />
        <div className={css(style.horizontalCardsWrapper)}>
          <div className={css(style.horizontalCardsContainer)}>
            {moreCards.map(createCard)}
          </div>
        </div>
      </div>
      )}
    </ErrorBoundary>
  );
};
